import styled from 'styled-components';
import { ChatTriggerButton } from '@mews-commander/chat';

interface ChatTriggerButtonProps {
    isSalesForceChatInitialized: boolean;
}
const ChatTriggerButtonDiv = styled.div`
    position: sticky;
    right: 0px;
    bottom: 0px;
`;
const ChatTriggerButtonComponent: React.FC<ChatTriggerButtonProps> = ({ isSalesForceChatInitialized }) => {
    if (!isSalesForceChatInitialized) {
        return null;
    }

    return (
        <ChatTriggerButtonDiv>
            <ChatTriggerButton />
        </ChatTriggerButtonDiv>
    );
};
export default ChatTriggerButtonComponent;
